import React from 'react';
import PropTypes from 'prop-types';
import './FormUploadField.scss';
import ImageUpload from '../common/ImageUpload';

const provideFile = delegate => file => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => delegate({ url: reader.result, name: file.name });
};

const FormImageField = ({
  input,
}) => {
  return (
    <div>
      <ImageUpload onFilePicked={provideFile(input.onChange)} photoUrl={input.value ? input.value.url : ''} />
    </div>
  );
};

FormImageField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
};

export default FormImageField;



// WEBPACK FOOTER //
// ./src/components/form/FormImageField.js